// extracted by mini-css-extract-plugin
export default {"Container":"Container_Container__ChJIx","formConatainer":"Container_formConatainer__XS+KP","Form":"Container_Form__W+pds"};